module.exports = __webpack_public_path__ + "img/gdq_gbt859_1987.prt.577b3b79.jpg";